export default {
    url: 'ecocredits',
    include: ['us', 'jp', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'za', 'eu', 'kr', 'sa'],
};
